
import ViewLegalFooter from "./legalFooter";

export default function GaijinToolPanel({ type, caption, children, additional }) {
  return (
    <div id="appBody">
      <div className="appScreen" screen="signIn">
        <div className="centeredBlock">
          {children}
        </div>
        <ViewLegalFooter />
      </div>
    </div>
  )
}